import { Outlet } from "react-router-dom";
import { ProductCatalogProvider } from "@/context/ProductCatalogContext";
export const ShopProductsLayout = () => {
  return (
    <ProductCatalogProvider>
      <Outlet />
    </ProductCatalogProvider>
  );
};
